const REFERRER_STORAGE_KEY = 'referrer';

export const captureReferrer = (): void => {
  if (typeof window === 'undefined') return;

  const referrer = document.referrer;

  if (!referrer) return;

  try {
    if (new URL(referrer).host === window.location.host) return;

    if (sessionStorage.getItem(REFERRER_STORAGE_KEY)) return;

    sessionStorage.setItem(REFERRER_STORAGE_KEY, referrer);
  } catch {
    return;
  }
};

export const getReferrer = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;

  try {
    return sessionStorage.getItem(REFERRER_STORAGE_KEY) || undefined;
  } catch {
    return undefined;
  }
};
